// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/vercel/17791f6a/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/vercel/17791f6a/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

